/// <reference path="../_references.ts"/>

module App.TemplateStore {
	import TitleBarService = App.Helpers.TitleBarService;
	import BannerService = App.WorkOrder.BannerService;
	import Department = App.Appointments.Department;

	interface ILocationProvider extends ng.ILocationProvider {
        search: () => {[index: string]: string};
    }

	export class TemplateViewController {
		downloadTemplateHelpText: string = 'Select a logical department to store this template\'s products. This department will also determine pricing for this template.';

		loading: boolean = true;
		template: TemplateDetails;
		showRating: boolean = true;
		rating: number = 1;
		fromOffice: boolean = false;

		//TODO Get from Organization
		tokenCount: number = 0;
		favoriteTemplate: boolean = false;
		getFlyoutActive: boolean = false;

		departmentList: Department[] = [];
		selectedDepartment: number = null;

		static $inject = ['$scope', '$sce', '$state', 'TemplateStoreService', 'TitleBarService', 'BannerService', '$location', '$document'];
		constructor(
			private $scope: ng.IScope,
			private $sce: ng.ISCEService,
			private $state: ng.ui.IStateService,
			private TemplateStoreService: TemplateStoreService,
			private TitleBarService: TitleBarService,
			public BannerService: BannerService,
			public $location: ILocationProvider,
			public $document: ng.IDocumentService
		) {
			const vm = this;
			let params = {},
				headers = {};

			$scope.$watch(() => vm.getFlyoutActive, (newVal: boolean) => {
				if(!newVal) {
					this.showRating = true;
				}
			});

			if ($location.search().office){
				this.fromOffice = true;
				TitleBarService.set('');
				$document.find("header")[0].className += " hide";

				params = {
					custom: 1,
					location: $location.search().locationId,
					after_hours: $location.search().afterHours,
					customer_type: $location.search().customerType,
				};

				headers = {
					organization: $location.search().orgId,
				};
			}

			TitleBarService.set('Rachel\'s Place', 'pinkText');

			if ($location.search().downloaded) {
				vm.TemplateStoreService.getDownloadedTemplateDetails(vm.$state.params['id'], params, headers).then((response) => {
					vm.template = response.data;
					vm.sortPackages();
					vm.loading = false;
				});
			} else {
				vm.TemplateStoreService.getTemplateDetails(vm.$state.params['id']).then((response) => {
					vm.template = response.data;
					vm.sortPackages();
					vm.loading = false;
				});
			}

			vm.getDepartments();
		}

		sortPackages() {
			const vm = this;
			let packages = vm.template.packages;

			packages.sort((a, b) => {
				if (a.index > b.index) return 1; return -1;
			});

			for(let i = 0; i < packages.length; i++){
				vm.sortProducts(packages[i]);
			}

			return packages;
		}

		sortProducts(pkg: TemplateDetailPackage) {
			let services = pkg.services;

			services.sort((a,b) => {
				if (a.index > b.index) return 1; return -1;
			});

			return pkg;
		}

		toggleGetTemplateFlyout() {
			this.getFlyoutActive = !this.getFlyoutActive;
		}

		getDepartments() {
			const vm = this;

			vm.TemplateStoreService.getDepartments().then((response) => {
				vm.departmentList = response.data;
			});
		}

		downloadTemplate() {
			const vm = this;

			if(!vm.selectedDepartment) {
				alert('A department must be selected');
				return;
			}

			let options: DownloadTemplateOptions = {
				department: vm.selectedDepartment,
				favorited: vm.favoriteTemplate
			}
			vm.TemplateStoreService.rateTemplate(vm.template.id, vm.rating).then(() => {
				vm.TemplateStoreService.downloadTemplate(vm.template.id, options).then(() => {
					vm.$state.go('zipSolutions.template-store');
				});
			});
		}

		selectDepartment(departmentId: number) {
			this.selectedDepartment = departmentId;
		}

		getRegularPricing(pkg: TemplateDetailPackage): string {
			let price = '$';

			switch(pkg.mode) {
				case 'admin':
					price = 'Admin';
					break;
				case 'regular':
				case 'whilehere':
					price += pkg.prices[pkg.mode].regular;
					break;
				case 'itemized':
					price += pkg.prices[pkg.mode].whilehere;
					break;
				default:
					price += pkg.prices.regular.regular;
					break;
			}

			return price;
		}

		isWhileHere(pkg: TemplateDetailPackage): boolean {
			return pkg.mode === 'whilehere';
		}

		secureIframeSrc(videoId: string) {
			const vm = this;
			return vm.$sce.trustAsResourceUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1`);
		}

		goBack() {
			this.$state.go('zipSolutions.template-store');
		}
	}
}